import { Link } from "react-router-dom";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import { PageHero } from "@/components/sections/PageHero";

const services = [
  {
    icon: "/icons/training.png",
    title: "Guidance for Project Selection",
    description: "We carry out a scientific survey of business ideas. Our survey consists of local raw material availability, local manpower availability, local market availability, product scalability, etc."
  },
  {
    icon: "/icons/loading-sign.png",
    title: "Project Design",
    description: "Based on market study and budget we design projects on small scale, medium scale, or large scale. Our designs are optimized for efficiency and productivity."
  },
  {
    icon: "/icons/factory.png",
    title: "Manufacturing",
    description: "Based on project design we manufacture excellent quality equipment. Our manufacturing facility ensures precision and durability in every product."
  },
  {
    icon: "/icons/tools.png",
    title: "Installation",
    description: "Most of the projects supplied by us are ready-to-install types. For medium scale and large-scale projects, our team is always ready for installations on site."
  },
  {
    icon: "/icons/headset.png",
    title: "Marketing Assistance",
    description: "Once our supplied project is installed and commissioned, we do assist entrepreneurs in marketing products manufactured from our project/industry."
  },
  {
    icon: "/icons/services.png",
    title: "After Sales Service",
    description: "Normally we keep ready stocks of spare parts required for projects supplied by us. Our dedicated support team ensures minimal downtime for your operations."
  },
  {
    icon: "/icons/synchronize.png",
    title: "Technology Transfer",
    description: "We also do total technology transfer projects in the food, Agri, and Engineering sectors. Complete knowledge transfer and training included."
  }
];

export default function Services() {
  return (
    <>
      <Header />
      <main>
        <PageHero title="Our Services" breadcrumb="Services" />
        
        <section className="py-[80px] bg-white">
          <div className="container mx-auto px-4 max-w-[1200px]">
            <div className="text-center mb-[60px] max-w-[800px] mx-auto">
              <h2 className="font-display font-bold text-[28px] text-[#001d3d] uppercase tracking-wider mb-4">
                What We Offer
              </h2>
              <p className="text-[#4a5568] text-[16px] leading-[1.6]">
                We provide comprehensive services to help industries and entrepreneurs build and grow their nations through our expertise and experience.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div 
                  key={index} 
                  className="bg-white border border-[#e2e8f0] p-8 rounded-lg shadow-card card-hover"
                >
                  <div className="w-[80px] h-[80px] mb-6">
                    <img 
                      src={service.icon} 
                      alt={service.title} 
                      className="w-full h-full object-contain"
                    />
                  </div>
                  
                  <h3 className="font-display font-bold text-[18px] text-[#001d3d] leading-[1.4] mb-4 uppercase">
                    {service.title}
                  </h3>
                  
                  <p className="text-[#4a5568] text-[15px] leading-[1.7]">
                    {service.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-[80px] bg-black text-white">
          <div className="container mx-auto px-4 max-w-[1200px]">
            <div className="text-center mb-[50px]">
              <h2 className="font-display font-bold text-[28px] uppercase tracking-wider mb-4">
                Our Process
              </h2>
              <p className="text-white/70 text-[16px] max-w-[600px] mx-auto">
                We follow a systematic approach to deliver successful projects
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#17A2B8] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="font-display font-bold text-[24px]">1</span>
                </div>
                <h4 className="font-display font-bold text-[16px] mb-2">Consultation</h4>
                <p className="text-white/60 text-[14px]">Understanding your requirements and goals</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#17A2B8] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="font-display font-bold text-[24px]">2</span>
                </div>
                <h4 className="font-display font-bold text-[16px] mb-2">Design</h4>
                <p className="text-white/60 text-[14px]">Creating optimized project blueprints</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#17A2B8] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="font-display font-bold text-[24px]">3</span>
                </div>
                <h4 className="font-display font-bold text-[16px] mb-2">Implementation</h4>
                <p className="text-white/60 text-[14px]">Manufacturing and installation</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#17A2B8] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="font-display font-bold text-[24px]">4</span>
                </div>
                <h4 className="font-display font-bold text-[16px] mb-2">Support</h4>
                <p className="text-white/60 text-[14px]">Ongoing maintenance and assistance</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-[80px] bg-[#f8f9fa]">
          <div className="container mx-auto px-4 max-w-[1200px] text-center">
            <h2 className="font-display font-bold text-[28px] text-[#001d3d] mb-6 uppercase tracking-wider">
              Ready to Get Started?
            </h2>
            <p className="text-[#4a5568] text-[16px] mb-8 max-w-[600px] mx-auto">
              Let us help you build your next successful project. Contact us today for a free consultation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contact" 
                className="inline-block px-10 py-4 bg-[#17A2B8] text-white font-display font-semibold uppercase tracking-wider rounded-[2px] hover:bg-[#138496] transition-colors"
              >
                Contact Us
              </Link>
              <Link 
                to="/downloads" 
                className="inline-block px-10 py-4 border-2 border-[#001d3d] text-[#001d3d] font-display font-semibold uppercase tracking-wider rounded-[2px] hover:bg-[#001d3d] hover:text-white transition-colors"
              >
                Download Catalogue
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
